module.exports = __webpack_public_path__ + "virgin-islands.svg?2031b4d3f97fbfeb47f0aed5c3a9da5e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/virgin-islands.svg
// module id = 340
// module chunks = 10